export const SET_APP = 'SET_APP';
export const SET_MENU = 'SET_MENU';
export const SET_LOADING = 'SET_LOADING';
export const SET_HEADER = 'SET_HEADER';
export const SET_FILTER = 'SET_FILTER';
export const TOGGLE_CONFIRM_MODAL = 'TOGGLE_CONFIRM_MODAL';
export const TOGGLE_LOADING_SCREEN = 'TOGGLE_LOADING_SCREEN';
